/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const TreeNode = require('../TreeNode');
const Q_enemy_adjacent = require('./Q_enemy_adjacent');
const BattleCalc = require('../../BattleCalc');

const Q_who_closer = function (actor, battleState, aggroNode, moveTowards) {
  const node = new TreeNode(actor, battleState);

  // branch indexes
  node.ALLY = 0;
  node.ENEMY = 1;

  if (actor.ai.settings.autoMove) {
    node.branches[node.ALLY] = moveTowards;
  } else {
    node.branches[node.ALLY] = new TreeNode(null, null);
  }

  node.branches[node.ENEMY] = new Q_enemy_adjacent(
    node.branches[node.ALLY],
    aggroNode,
    actor,
    battleState
  );

  node.query = function (allyAndMenacer) {
    // input should be a container where [0] is the injured ally and [1] is his nearest enemy
    const ally = allyAndMenacer[0];
    const menacer = allyAndMenacer[1];

    if (
      BattleCalc.boardDistance(this.actor, ally) <
      BattleCalc.boardDistance(this.actor, menacer)
    ) {
      return this.branches[this.ALLY].query(menacer);
    } else {
      return this.branches[this.ENEMY].query(menacer);
    }
  };

  return node;
};
module.exports = Q_who_closer;
